<template>
	<SOSlotBase
		:is-search="isSearch"
		:bg-grey="true"
		:container-name="pageSetting.containerName"
	>
		<template v-slot:title-bar>
			<SOTitleBar
				v-if="!isSearch"
				:page-title="pageSetting.pageTitle"
				:type="'back'"
				:show-search="true"
				@search="search"
				@back="back"
			/>
		</template>

		<template v-slot:search-bar>
			<SOSearchBar
				v-if="isSearch && !pageSetting.loading.export"
				:value="searchKey.key"
				:data-count="rekeningBank.data.jumlah_data === 0 ? 0 : rekeningBank.data.jumlah_data"
				:waiting="pageSetting.search.waiting"
				:search-information="'Nama rekening bank, Kode akun, Nomor rekening, Atas nama, Keterangan.'"
				@return-search-value="(v) => { searchKey.key = v }"
				@loading="loadingSearch"
				@do-search="searchRekeningBank"
				@close="closeSearch"
			/>
		</template>

		<template v-slot:empty-state>
			<div v-if="rekeningBank.data !== undefined">
				<SOEmptyState
					v-if="rekeningBank.data.jumlah_data === 0 && !isSearch"
					:message="'Belum ada rekening bank'"
					:sub-message="'Klik tombol + untuk menambahkan'"
				/>
				<SOEmptySearchState
					v-if="isSearch && !pageSetting.loading.list && !pageSetting.search.waiting && rekeningBank.data.jumlah_data === 0 && searchKey.key.length > 1"
					@action="() => { resetFilter(); searchKey.key = '' }"
				/>
			</div>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-t-16 w-limit" v-if="!pageSetting.loading.list">
				<SOHeaderList
					:title="rekeningBank.data.jumlah_data === 0 && isSearch ? '' : `${rekeningBank.data.jumlah_data} Rekening`"
					:show-filter="true"
					@filter="() => { pageSetting.showFilter = true }"
				/>

				<div class="p-d-16" v-for="rek in rekeningBank.data.data_array" :key="rek.id">
					<SOSlotCard :cardType="'shadow'">
						<template v-slot:card_head>
							<div class="d-flex-between-center">
								<label class="f-semi f-c-black f-16 m-d-0" style="max-width: 70%;" v-if="!isSearch">{{ rek.nama }}</label>
								<label class="f-semi f-c-black f-16 m-d-0" style="max-width: 70%;" v-else
								       v-html="searchHighlight(rek.nama, searchKey.key)"></label>
								<div class="align-self-baseline">
								<span class="f-regular f-12 f-c-midgrey label-akun-rekening" v-if="!isSearch">
									{{ rek.idakun_keuangan }}
								</span>
									<span class="f-regular f-12 f-c-black label-akun-rekening" v-else
									      v-html="searchHighlight(rek.idakun_keuangan, searchKey.key)">
								</span>
									<img src="@/assets/icons/chevron_right_4.svg" alt=""/>
								</div>
							</div>
						</template>
						<template v-slot:card_body>
							<div class="f-regular f-13 f-c-midgrey" v-if="!isSearch">
								{{ rek.nomor_rekening }}
							</div>
							<div class="f-regular f-13 f-c-black" v-else
							     v-html="searchHighlight(rek.nomor_rekening, searchKey.key)">
							</div>
							<div class="f-regular f-13 f-c-midgrey" v-if="!isSearch">
								{{ rek.pemilik_rekening }}
							</div>
							<div class="f-regular f-13 f-c-black" v-else
							     v-html="searchHighlight(rek.pemilik_rekening, searchKey.key)">
							</div>
							<div class="f-regular f-13 f-c-midgrey" v-if="rek.keterangan !== ''">
								Keterangan: {{ rek.keterangan }}
							</div>
							<div class="clik" @click="detail(rek.id, $event)"></div>
						</template>
					</SOSlotCard>
				</div>

				<SOLoadMoreLoading
					v-if="rekeningBank.data.jumlah_data > 0"
					:id="pageSetting.idLoadMore"
					:loading="pageSetting.loading.loadMore"
				/>

				<SOFABRegular @add="create" v-if="!isSearch && validateAccess('bank.create')"/>
			</div>
		</template>

		<template v-slot:filter>
			<SOFilter
				v-if="pageSetting.showFilter"
				:sorting="sorting"
				:filter-rekening-bank="true"
				@back="() => { pageSetting.showFilter = false }"
				@do-filter="doFilter"
				@reset-filter="resetFilter"
			/>
		</template>

	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import SOFilter from "@/so-components/global/filter/base/SOFilter";

export default {
	name: "RekeningBank",
	components: {
		SOSlotBase,
		SOTitleBar,
		SOSearchBar,
		SOEmptySearchState,
		SOEmptyState,
		SOHeaderList,
		SOSlotCard,
		SOLoadMoreLoading,
		SOFABRegular,
		SOFilter,
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			rekeningBank: "getRekeningBank",
			pagination: "getPagination",
			searchKey: "getSearch",
			isSearch: "getIsSearch",
			scrollPosition: "getScrollPosition",
		}),
		...mapGetters("filterGlobalModule", {
			filter: "getFilter",
			filterItem: "getFilterItem",
		}),
	},
	data() {
		return {
			sorting: [
				{
					label: "Abjad A-Z",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "",
						orderBy: "ASC",
					}),
					id: "sorting-1"
				},
				{
					label: "Abjad Z-A",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "",
						orderBy: "DESC",
					}),
					id: "sorting-2"
				},
			],
			pageSetting: {
				containerName: "list-rekening-bank",
				idLoadMore: "loading-list-rekening-bank",
				pageTitle: "Rekening Bank",
				showFilter: false,
				loading: {
					list: true,
					loadMore: false,
				},
				search: {
					waiting: false,
				},
				error: {
					list: false,
				}
			}
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			let query = vm.$route.query
			if (from.path.split("/")[1] !== "rekening-bank") {
				vm.initRekeningBank(query)
			} else {
				if (vm.rekeningBank.data === undefined) {
					vm.initRekeningBank(query)
					return
				}
				vm.setScrollPosition()
			}
		})
	},
	async mounted() {
		await this.scroll()
		this.smartTrackingView("rekening_bank");

	},
	methods: {
		back() {
			this.$router.push("/dashboard")
		},

		async initRekeningBank(query) {
			await this.flushData()

			await this.setDefaultFilter(query)
			await this.listRekeningBank()
		},
		async setDefaultFilter(query) {
			await this.$store.commit("filterGlobalModule/resetFilterItem")
			if (Object.keys(query).length > 0) {
				let filterItem = this.filterItem
				if (query.sort) this.filter.orderBy = query.sort
				if (query.filter_by) filterItem.periode.filterBy = query.filter_by
				if (query.atas_nama) filterItem.rekeningAtasNama = (Array.isArray(query.atas_nama)) ? query.atas_nama : [query.atas_nama]

				await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

				if (query.key) {
					await this.$store.commit("rekeningBankModule/setSearch", query.key)
					await this.$store.commit("rekeningBankModule/setIsSearch", true)
				}

				let temp = this.filter
				temp.sortBy = query.sort_by
				temp.orderBy = query.order_by
				await this.$store.commit("filterGlobalModule/setFilter", temp)
			} else {
				await this.resetFilter()
			}

			await this.$store.commit("rekeningBankModule/resetPagination")
		},
		async listRekeningBank() {
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			}
			if (this.rekeningBank.data !== undefined && this.rekeningBank.data.lenght === 0) {
				this.pageSetting.search.waiting = true
			}
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankList")
			this.pageSetting.loading.list = false
			this.pageSetting.loading.loadMore = false
			this.pageSetting.search.waiting = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("rekeningBankModule/setNextPagination", {data: this.rekeningBank.data})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},

		create() {
			this.$router.push({name: "RekeningBank.Create"})
			this.smartTrackingClick("add_rekening_bank");

		},
		detail(id, event) {
			this.$store.commit("rekeningBankModule/setScrollPosition", event.pageY)
			this.$router.push({name: "RekeningBank.Detail", params: {id: id}})
			this.smartTrackingClick("detail_rekening_bank");

		},

		// scroll
		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: this.pageSetting.idLoadMore,
					container: this.pageSetting.containerName,
					pagination: this.pagination,
					callback: this.listRekeningBank,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		setScrollPosition() {
			this.pageSetting.loading.list = false
			setTimeout(() => {
				window.scrollTo(0, this.scrollPosition)
			}, 5)
		},

		// search
		async searchRekeningBank(search) {
			await this.$store.commit("rekeningBankModule/resetSearch")
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			await this.$store.commit("rekeningBankModule/resetPagination")

			await this.$store.commit("rekeningBankModule/setSearch", search)
			await this.listRekeningBank()
			this.pageSetting.search.waiting = false
		},
		async search() {
			window.scrollTo(0, 0)
			await this.$store.commit("rekeningBankModule/setIsSearch", true)

			this.rekeningBank.data.data_array = []
			this.rekeningBank.data.jumlah_data = 0
			await this.$store.commit("rekeningBankModule/resetSearch")
			await this.$store.commit("rekeningBankModule/resetPagination")
		},
		async loadingSearch(loading) {
			if (!loading) {
				this.rekeningBank.data.data_array = []
				this.rekeningBank.data.jumlah_data = 0
			}
			this.pageSetting.search.waiting = loading
			this.pageSetting.loading.list = loading
		},
		async closeSearch() {
			await this.$router.replace({'query': null});
			this.pageSetting.loading.list = true
			await this.$store.commit("rekeningBankModule/setIsSearch", false)

			await this.$store.commit("rekeningBankModule/resetSearch")
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			await this.$store.commit("rekeningBankModule/resetPagination")

			await this.listRekeningBank()
			this.pageSetting.loading.list = false
		},

		// filter
		async doFilter() {
			this.pageSetting.showFilter = false
			if (this.isSearch && this.searchKey.key.length < 2) {
				return
			}
			this.pageSetting.loading.list = true
			this.pageSetting.search.waiting = true
			await this.$store.commit("rekeningBankModule/resetPagination")
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			await this.listRekeningBank()
		},
		async resetFilter() {
			let temp = this.filter
			temp.sortBy = ""
			temp.orderBy = "ASC"
			await this.$store.commit("filterGlobalModule/resetFilterItem")
			await this.$store.commit("filterGlobalModule/setFilter", temp)
		},

		async flushData() {
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			await this.$store.commit("rekeningBankModule/resetPagination")
			await this.$store.commit("filterGlobalModule/resetFilter")
			await this.$store.commit("rekeningBankModule/resetSearch")
			await this.$store.commit("rekeningBankModule/setIsSearch", false)
		}
	},
}
</script>

<style scoped>
.label-akun-rekening {
	border: 1px solid #EDEDED;
	border-radius: 4px;
	padding: 2px 4px;
}

.card-body-no-footer {
	border-bottom: none !important;
	padding-bottom: 0 !important;
}
</style>